import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import {Typography, Button} from '@material-ui/core';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import styled from 'styled-components';

const ButtonSty = styled.div`
  a{
    text-decoration: none;
    color: white
  }
  .btn{
    background-color: #095EB2!important;
    transition: all 0.7s;
    &:hover{
      opacity: 0.9;
    }
  }
  
`;
const Div = styled.div`
  a{
    backgroun-color: white;
  }
  
  #l2{
    background-color: #095EB2;
    color: white;
  }
  .bodyTxt{
    padding: 30px 30px 30px 0px;
    width: 86%;
    margin-left: 7%;
  }
  ol{
    margin-left: 40px;
    li{
      padding: 10px;
    }
  }
  .obs{
    margin: 15px 0px;
    font-weight: bold;
  }
`;

const Title = styled.div`
  border-bottom: 1px solid rgb(240, 240, 240);
  padding: 30px 30px 30px 0px;
  font-size: 40px;
  width: 86%;
  margin-left: 7%;
`;

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function Homologacao(props) {
  const [expanded, setExpanded] = React.useState('panel1');
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  let location = useLocation();
  

  return (
    <>
      <Div className="Homologar">
      <Header />
      <Title>Homologação de Estudos Superiores</Title>
      <div className='bodyTxt'>
        
        {(location.state.value != 0 && location.state.value != 3) &&(
          <>
            <Typography variant="h5" gutterBottom style={{fontWeight: "bold"}}>
              {location.state.title} - {location.state.span}
            </Typography>

            {props.dados1.map((item, key) => key == 1 && (
              <Typography key={item.titulo} variant="body1" gutterBottom dangerouslySetInnerHTML={{__html: item.descricao}}>
                  
              </Typography>
            ))}
            <Typography className="obs" variant="body1">
              Obs: Botão abaixo redicionará para o portal Sepe, o utente deverá estar logado  e aderir o respectivo formulário
            </Typography>
            <ButtonSty>
              <a href={(location.state.value == 1)? 'https://www.sepe.gov.ao/ao/catalogo/mais-servicos/homologacao-de-estudos-feitos-em-angola/homologacao-de-estudos-graus-licenciado-mestre-e-doutor/': 'https://www.sepe.gov.ao/ao/catalogo/mais-servicos/homologacao-de-estudos-feitos-em-angola/homologacao-de-estudos-grau-academico-bacharel/'} target="_blank">
              <Button
                variant="contained"
                className="btn" 
                color="primary" 
                disableElevation>
                  Preencher Formulário
              </Button>
              </a>
            </ButtonSty>
          </>
        )}
        {location.state.value == 3 &&(
          <>
            <Typography variant="h5" gutterBottom style={{fontWeight: "bold"}}>
              {location.state.title} - {location.state.span}
            </Typography>
            {props.dados1.map((item, key) => key == 7 && (
              <Typography key={item.titulo} variant="body1" gutterBottom dangerouslySetInnerHTML={{__html: item.descricao}}>
                  
              </Typography>
            ))}
            <Typography className="obs" variant="body1">
              Obs: Botão abaixo redicionará para o portal Sepe, o utente deverá estar logado  e aderir o respectivo formulário
            </Typography>
            <ButtonSty>
            <a href='https://www.sepe.gov.ao/ao/catalogo/mais-servicos/homologacao-de-estudos-feitos-em-angola/homologacao-de-estudos-nao-concluidos/' target="_blank">
            <Button
              variant="contained"
              className="btn" 
              color="primary" 
              disableElevation>
                Preencher Formulário
              </Button>
            </a>
          </ButtonSty>
          </>
        )}
        {location.state.value == 0 && (
          <>
            <Typography variant="h5" gutterBottom style={{fontWeight: "bold"}}>
              {props.dados.name}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {props.dados.description}
            </Typography>
          </>
        )}
      </div>
     
      {location.state.value == 0 && (
        <div style={{width:'86%', marginLeft: '7%'}}>
        {props.dados1.map((item, key) => (
          <Accordion key={item.id} square expanded={expanded === `panel${key+1}`} onChange={handleChange(`panel${key+1}`)} >
            <AccordionSummary aria-controls={`panel${key+1}d-content`} id={`panel${key+1}d-header`}>
              <Typography>{item.titulo}</Typography>
            </AccordionSummary>
        
            <AccordionDetails>
              <Typography variant="body1" gutterBottom dangerouslySetInnerHTML={{__html: item.descricao}}>
                
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
        </div>)}

    <Footer/>
    
    </Div>
   
    </>
  );

  
}

